module.exports = __webpack_public_path__ + "static/media/unchecked-small.6cf672da.svg";